export default {"src":"/_next/static/media/bg_blue_gradient.8d444a8e.svg","height":272,"width":483,"blurWidth":0,"blurHeight":0};